var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,88.273H341.333v335.448h132.322c21.177,0,38.345-17.167,38.345-38.345V126.618 C512,105.44,494.833,88.273,473.655,88.273z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 88.277,
    style: {
      fill: "#FFE15A"
    },
    width: 170.67,
    height: 335.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M38.345,88.273C17.167,88.273,0,105.44,0,126.618v258.759c0,21.177,17.167,38.345,38.345,38.345 h132.322V88.273H38.345z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.623,
    y: 286.599,
    transform: "matrix(-0.775 0.6319 -0.6319 -0.775 687.1577 360.2314)",
    style: {
      fill: "#FFCD5A"
    },
    width: 5.666,
    height: 31.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.192,
    y: 288.604,
    transform: "matrix(-0.7753 0.6316 -0.6316 -0.7753 672.8598 351.7617)",
    style: {
      fill: "#FFBE5A"
    },
    width: 11.329,
    height: 13.937
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.152,
    y: 286.617,
    transform: "matrix(0.775 0.6319 -0.6319 0.775 243.9905 -80.4506)",
    style: {
      fill: "#FFCD5A"
    },
    width: 5.666,
    height: 31.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.918,
    y: 288.603,
    transform: "matrix(0.7753 0.6316 -0.6316 0.7753 240.742 -85.5351)",
    style: {
      fill: "#FFBE5A"
    },
    width: 11.329,
    height: 13.937
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "250.14,297.584 235.977,325.91 255.805,340.073 255.805,300.416 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "261.471,297.584 275.634,325.91 255.805,340.073 255.805,300.416 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M216.148,297.584v-73.65h8.498c0,0,0,48.156,0,56.653S216.148,297.584,216.148,297.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M210.482,311.747v-87.814h8.498c0,0,0,62.319,0,70.817 C218.979,303.248,210.482,311.747,210.482,311.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M204.817,323.078v-99.144h8.498c0,0,0,73.65,0,82.148 C213.315,314.579,204.817,323.078,204.817,323.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M224.646,226.766c0,0,0,40.365,0,53.821c0,14.164,20.537,12.275,31.159,22.661 c10.623-10.387,31.159-8.498,31.159-22.661c0-13.455,0-53.821,0-53.821H224.646L224.646,226.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M224.646,257.926c0,8.968,0,17.668,0,22.662c0,14.164,20.537,12.275,31.159,22.661 c10.623-10.387,31.159-8.498,31.159-22.662c0-4.993,0-13.694,0-22.662L224.646,257.926L224.646,257.926z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "255.805,294.75 247.307,289.085 247.307,286.252 250.14,283.42 250.14,266.423  241.642,260.758 250.14,249.427 252.972,249.427 255.805,252.261 258.638,249.427 261.471,249.427 269.969,260.758  261.471,266.423 261.471,283.42 264.303,286.252 264.303,289.085  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M244.474,229.599c0,0-11.33,2.833-11.33,14.164c0,11.33,11.33,16.996,11.33,16.996l5.665-8.498 C233.143,246.595,244.474,229.599,244.474,229.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M267.136,229.599c0,0,11.33,2.833,11.33,14.164c0,11.33-11.33,16.996-11.33,16.996l-5.665-8.498 C278.466,246.595,267.136,229.599,267.136,229.599z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "227.478,257.926 233.143,260.758 238.809,257.926 233.143,255.093  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "272.801,257.926 278.466,260.758 284.132,257.926 278.466,255.093  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "255.805,231.015 257.865,233.125 260.812,233.089 260.778,236.037 262.887,238.097  260.778,240.157 260.812,243.104 257.865,243.069 255.805,245.179 253.746,243.069 250.797,243.104 250.833,240.157  248.724,238.097 250.833,236.037 250.797,233.089 253.746,233.125  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M236.568,270.297l2.042,2.272l2.84-1.126c1.471-0.583,2.851,1.016,2.059,2.386l-1.529,2.645 l1.949,2.354c1.009,1.218-0.086,3.026-1.633,2.696l-2.988-0.638l-1.636,2.581c-0.847,1.336-2.904,0.853-3.069-0.721l-0.318-3.039 l-2.959-0.758c-1.533-0.393-1.709-2.498-0.264-3.14l2.792-1.24l-0.193-3.049C233.564,269.938,235.511,269.12,236.568,270.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M274.297,276.755c0.625-3.222,3.283-5.503,6.382-5.847c-0.636-0.342-1.312-0.625-2.057-0.769 c-3.968-0.769-7.808,1.824-8.577,5.791c-0.769,3.968,1.823,7.808,5.791,8.577c0.746,0.145,1.479,0.136,2.195,0.056 C275.286,283.086,273.673,279.977,274.297,276.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M244.474,226.766l5.665-28.327l-11.33-8.498l2.833-2.833h5.665c0,0,2.833-2.833,8.498-2.833 c5.665,0,11.33,2.833,11.33,11.33s2.833,31.159,2.833,31.159h-25.494V226.766z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA5A"
    },
    d: "M224.646,215.435c-6.258,0-11.33,5.073-11.33,11.33h22.662 C235.977,220.508,230.903,215.435,224.646,215.435z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M221.813,226.766h-16.996v-18.855c0-3.667,2.973-6.639,6.639-6.639h3.718 c3.667,0,6.639,2.973,6.639,6.639L221.813,226.766L221.813,226.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M295.463,297.584v-73.65h-8.498c0,0,0,48.156,0,56.653S295.463,297.584,295.463,297.584z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M301.128,311.747v-87.814h-8.498c0,0,0,62.319,0,70.817S301.128,311.747,301.128,311.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M306.794,323.078v-99.144h-8.498c0,0,0,73.65,0,82.148 C298.295,314.579,306.794,323.078,306.794,323.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA5A"
    },
    d: "M286.965,215.435c6.258,0,11.33,5.073,11.33,11.33h-22.662 C275.634,220.508,280.707,215.435,286.965,215.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M289.798,226.766h16.996v-18.855c0-3.667-2.973-6.639-6.639-6.639h-3.717 c-3.667,0-6.639,2.973-6.639,6.639L289.798,226.766L289.798,226.766z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.827,
    y: 252.364,
    transform: "matrix(0.8541 0.5201 -0.5201 0.8541 194.9967 -114.1428)",
    style: {
      fill: "#FFAA5A"
    },
    width: 4.249,
    height: 76.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.413,
    y: 308.802,
    transform: "matrix(-0.6244 0.7811 -0.7811 -0.6244 712.6224 283.7963)",
    style: {
      fill: "#FFE15A"
    },
    width: 11.331,
    height: 8.861
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.955,
    y: 256.742,
    transform: "matrix(0.8542 0.5199 -0.5199 0.8542 183.8708 -125.9308)",
    style: {
      fill: "#FFCD5A"
    },
    width: 7.082,
    height: 16.344
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.231,
    y: 290.329,
    transform: "matrix(0.5429 0.8398 -0.8398 0.5429 342.3956 -45.5664)",
    style: {
      fill: "#73AF00"
    },
    width: 73.65,
    height: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M219.413,289.383c-1.016,1.152-1.69,2.899-1.86,4.913c-1.397-1.41-3.001-2.308-4.495-2.549 c-0.394,1.461-0.234,3.293,0.479,5.145c-1.907-0.672-3.775-0.775-5.242-0.321c0.413,2.088,2.114,4.354,4.721,5.909 c2.606,1.556,5.409,1.976,7.442,1.348l0.582-0.376c1.407-1.597,2.174-4.324,1.826-7.339 C222.515,293.098,221.146,290.617,219.413,289.383z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 220.75,
    cy: 303.647,
    r: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M208.648,272.731c-1.016,1.152-1.69,2.899-1.86,4.913c-1.397-1.41-3.001-2.308-4.495-2.549 c-0.394,1.461-0.234,3.293,0.479,5.145c-1.907-0.672-3.775-0.775-5.242-0.321c0.413,2.088,2.114,4.354,4.721,5.909 c2.606,1.556,5.409,1.976,7.442,1.348l0.582-0.376c1.407-1.597,2.174-4.324,1.826-7.339 C211.751,276.445,210.382,273.964,208.648,272.731z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 209.99,
    cy: 286.997,
    r: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M197.884,256.079c-1.016,1.152-1.69,2.899-1.86,4.913c-1.397-1.41-3.001-2.308-4.495-2.549 c-0.394,1.461-0.234,3.293,0.479,5.145c-1.907-0.672-3.775-0.775-5.242-0.321c0.413,2.088,2.114,4.354,4.721,5.909 c2.606,1.556,5.409,1.976,7.442,1.348l0.582-0.376c1.407-1.597,2.174-4.324,1.826-7.339 C200.985,259.793,199.617,257.312,197.884,256.079z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 199.22,
    cy: 270.347,
    r: 2.833
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.704,
    y: 308.815,
    transform: "matrix(0.6244 0.7811 -0.7811 0.6244 329.7009 -59.1636)",
    style: {
      fill: "#FFE15A"
    },
    width: 11.331,
    height: 8.861
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.81,
    y: 178.617,
    style: {
      fill: "#FFE15A"
    },
    width: 2.833,
    height: 19.829
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.97,
    y: 181.447,
    style: {
      fill: "#FFE15A"
    },
    width: 8.498,
    height: 2.833
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF875A"
    },
    points: "238.809,189.941 247.307,196.315 247.307,187.109 241.642,187.109 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA5A"
    },
    d: "M241.642,178.61v2.833h2.833v2.833h-2.833v2.833h5.665c0,0,2.833-2.833,8.498-2.833 s11.33,2.833,11.33,11.33c0,8.498,2.833,31.159,2.833,31.159h5.665c0-6.258,5.073-11.33,11.33-11.33 c0.984,0,1.922,0.164,2.833,0.401v-6.066c0-4.693,3.805-8.498,8.498-8.498s8.498,3.805,8.498,8.498v14.164v2.833v50.026l3.658-6.009 l-1.209-0.736l8.498-13.962l1.209,0.736l0,0l1.815,1.106l3.025,1.841l-8.498,13.962l-1.21-0.736l-7.288,11.974v38.113 c0,0-6.764-6.783-8.212-14.287c-1.035-1.33-2.227-3.026-3.276-4.952l-3.242,5.326l3.014,2.409l-7.075,8.851l-1.879-1.502 l-3.202,5.261l-3.629-2.21l3.485-5.726l-1.692-1.353l2.409-3.013l-7.433-9.116l-2.197,1.79l-6.609-8.11 c-1.759,0.707-3.498,1.484-5.171,2.372l13.547,27.095l-19.829,14.164l-19.829-14.164l13.547-27.095 c-1-0.531-2.016-1.034-3.055-1.492l-5.891,7.23l-2.197-1.79l-7.433,9.116l2.409,3.013l-2.406,1.923l3.288,5.086l-2.379,1.538 l-3.133-4.846l-2.287,1.828l-7.075-8.851l3.179-2.541l-1.685-2.607c-0.04,0.001-0.079,0.002-0.119,0.002 c-0.926,0-1.833-0.413-2.372-1.248c-0.23-0.355-0.354-0.743-0.409-1.135c-0.533-0.032-1.073-0.108-1.635-0.242 c-1.053,1.941-2.253,3.65-3.294,4.989c-1.447,7.505-8.212,14.287-8.212,14.287v-36.135c-0.856-0.269-1.719-0.611-2.568-1.118 c-2.606-1.556-4.308-3.822-4.721-5.909c0.596-0.184,1.257-0.276,1.961-0.276c1.03,0,2.15,0.199,3.282,0.597 c-0.369-0.96-0.584-1.91-0.655-2.81l-2.786-4.31c-0.04,0.001-0.079,0.002-0.119,0.002c-0.926,0-1.833-0.413-2.372-1.248 c-0.23-0.355-0.354-0.743-0.41-1.135c-1.568-0.094-3.286-0.574-4.943-1.562c-2.606-1.556-4.308-3.822-4.721-5.909 c0.596-0.184,1.258-0.276,1.961-0.276c1.03,0,2.15,0.198,3.282,0.597c-0.713-1.853-0.873-3.684-0.479-5.145 c1.494,0.241,3.098,1.139,4.495,2.549c0.17-2.014,0.844-3.761,1.859-4.913c1.734,1.234,3.102,3.715,3.45,6.731 c0.222,1.918-0.046,3.681-0.605,5.15c0.335,0.213,0.638,0.484,0.867,0.84c0.563,0.871,0.543,1.918,0.113,2.783l2.786,4.31 c0.108,0.06,0.214,0.132,0.322,0.199V226.77v-2.833v-14.164c0-4.693,3.805-8.498,8.498-8.498c4.693,0,8.498,3.805,8.498,8.498v6.066 c0.91-0.236,1.848-0.401,2.833-0.401c6.258,0,11.33,5.073,11.33,11.33h8.498l5.665-28.327l-2.833-2.124l-5.665-4.249v6.374h-2.833 v-14.164h-2.833v-2.833h2.833v-2.833h2.844 M287.114,307.353l1.046-1.309l0.557,0.445l4.566-7.501 c-0.398-1.387-0.653-2.81-0.653-4.237c0-0.139,0-0.33,0-0.498c-2.472-3.252-5.665-8.455-5.665-13.666 c0,5.966-3.662,9.074-8.674,11.462l4.36,5.351l-2.195,1.788L287.114,307.353 M224.769,307.253l1.514-1.21l1.046,1.309l6.658-8.167 l-2.195-1.788l3.605-4.424c-6.051-2.527-10.752-5.623-10.752-12.387c0,3.793-1.693,7.578-3.567,10.616 c0.89,1.306,1.561,2.976,1.785,4.91c0.222,1.918-0.046,3.681-0.605,5.15c0.335,0.213,0.638,0.484,0.867,0.84 c0.563,0.871,0.543,1.917,0.113,2.783L224.769,307.253 M241.642,176.486h-2.833c-1.173,0-2.124,0.951-2.124,2.124v0.708h-0.708 c-1.173,0-2.124,0.951-2.124,2.124v2.833c0,1.173,0.951,2.124,2.124,2.124h0.708v12.039c0,1.173,0.951,2.124,2.124,2.124h2.833 c1.173,0,2.124-0.951,2.124-2.124v-2.124l2.266,1.699l1.761,1.321l-5.062,25.306h-4.799c-1.022-6.413-6.591-11.33-13.288-11.33 c-0.235,0-0.47,0.008-0.708,0.022v-3.563c0-5.857-4.766-10.623-10.623-10.623s-10.623,4.766-10.623,10.623v14.164v2.833v32.578 c-0.767-2.115-2.014-3.885-3.577-4.998c-0.372-0.265-0.803-0.394-1.23-0.394c-0.591,0-1.177,0.246-1.594,0.719 c-0.654,0.743-1.192,1.647-1.593,2.667c-0.93-0.504-1.887-0.844-2.831-0.996c-0.114-0.019-0.227-0.028-0.339-0.028 c-0.945,0-1.795,0.632-2.049,1.571c-0.249,0.922-0.332,1.934-0.254,2.989c-0.167-0.008-0.333-0.012-0.498-0.012 c-0.92,0-1.791,0.125-2.588,0.371c-1.039,0.321-1.668,1.375-1.458,2.442c0.55,2.776,2.686,5.514,5.716,7.321 c1.398,0.834,2.916,1.406,4.457,1.685c0.062,0.117,0.129,0.231,0.201,0.342c0.697,1.079,1.791,1.821,3.042,2.098l1.548,2.395 c-0.052-0.001-0.103-0.001-0.154-0.001c-0.92,0-1.791,0.125-2.588,0.371c-1.039,0.321-1.668,1.375-1.458,2.442 c0.55,2.776,2.686,5.514,5.716,7.321c0.484,0.289,0.988,0.545,1.532,0.776v34.648c0,0.86,0.519,1.635,1.313,1.963 c0.263,0.108,0.538,0.161,0.811,0.161c0.554,0,1.098-0.216,1.505-0.625c0.289-0.289,6.952-7.042,8.689-14.879 c0.714-0.939,1.374-1.886,1.974-2.834c0.684,0.79,1.609,1.335,2.643,1.565l0.092,0.141l-1.678,1.342 c-0.44,0.352-0.723,0.864-0.785,1.425c-0.063,0.559,0.1,1.122,0.452,1.562l7.075,8.851c0.352,0.44,0.864,0.723,1.425,0.785 c0.078,0.009,0.157,0.013,0.235,0.013c0.48,0,0.948-0.162,1.326-0.465l0.452-0.361l1.857,2.873c0.306,0.473,0.787,0.806,1.338,0.924 c0.148,0.032,0.297,0.047,0.446,0.047c0.406,0,0.808-0.117,1.153-0.341l1.374-0.888l-0.311,0.623 c-0.468,0.935-0.185,2.071,0.665,2.679l19.829,14.164c0.37,0.264,0.802,0.396,1.235,0.396s0.865-0.132,1.235-0.396l19.829-14.164 c0.851-0.608,1.133-1.743,0.665-2.679l-12.597-25.195c0.534-0.252,1.091-0.502,1.674-0.753l5.609,6.883 c0.42,0.515,1.032,0.782,1.649,0.782c0.472,0,0.947-0.157,1.341-0.478l0.551-0.448l5.006,6.141l-1.338,1.674 c-0.352,0.44-0.514,1.002-0.452,1.562c0.063,0.561,0.345,1.073,0.785,1.425l0.232,0.185l-2.514,4.129 c-0.61,1.002-0.292,2.308,0.71,2.919l3.629,2.21c0.335,0.204,0.718,0.31,1.106,0.31c0.168,0,0.337-0.02,0.502-0.061 c0.547-0.134,1.02-0.478,1.313-0.96l1.947-3.199c0.391,0.309,0.855,0.459,1.318,0.459c0.623,0,1.241-0.274,1.661-0.798l7.075-8.851 c0.26-0.326,0.409-0.705,0.452-1.09c2.308,6.903,7.838,12.507,8.1,12.769c0.406,0.407,0.951,0.625,1.505,0.625 c0.274,0,0.548-0.053,0.811-0.161c0.794-0.329,1.313-1.103,1.313-1.963v-37.514l5.937-9.752c0.145,0.03,0.29,0.045,0.435,0.045 c0.717,0,1.417-0.363,1.817-1.021l8.498-13.962c0.294-0.481,0.383-1.059,0.249-1.607c-0.134-0.547-0.479-1.02-0.96-1.313 l-3.025-1.841l-1.814-1.105l-1.212-0.737c-0.344-0.21-0.726-0.309-1.101-0.309c-0.717,0-1.417,0.363-1.816,1.021l-7.007,11.512 v-39.725v-2.833v-14.164c0-5.857-4.766-10.623-10.623-10.623s-10.623,4.766-10.623,10.623v3.563 c-0.237-0.014-0.473-0.022-0.708-0.022c-6.697,0-12.266,4.917-13.288,11.33h-1.827c-0.67-5.577-2.59-22.173-2.59-29.035 c0-9.92-6.951-13.455-13.455-13.455c-4.817,0-7.925,1.836-9.258,2.833h-0.07c0.078-0.222,0.121-0.46,0.121-0.708v-2.833 c0-1.173-0.951-2.124-2.124-2.124h-0.708v-0.708C243.766,177.437,242.815,176.486,241.642,176.486L241.642,176.486z M223.55,291.199 c0.544-0.957,1.018-1.901,1.426-2.831c1.771,2.377,4.319,4.067,7.031,5.405l-1.86,2.283c-0.356,0.437-0.524,0.997-0.467,1.558 c0.057,0.561,0.334,1.076,0.771,1.431l0.546,0.446l-3.785,4.642c-0.216-0.106-0.451-0.174-0.695-0.202 c-0.078-0.009-0.158-0.013-0.235-0.013c-0.212,0-0.42,0.032-0.621,0.093c0.097-1.068-0.156-2.14-0.751-3.062 c-0.072-0.111-0.149-0.22-0.23-0.324c0.378-1.519,0.48-3.138,0.294-4.756C224.782,294.208,224.295,292.618,223.55,291.199 L223.55,291.199z M281.579,292.722c1.871-1.091,3.688-2.473,5.066-4.33c1.085,2.477,2.511,4.73,3.861,6.569 c0.017,1.183,0.179,2.401,0.491,3.694l-3.225,5.299c-0.186,0.034-0.37,0.094-0.543,0.179l-3.785-4.642l0.546-0.446 c0.437-0.356,0.714-0.871,0.771-1.431s-0.11-1.121-0.467-1.558L281.579,292.722L281.579,292.722z M240.576,306.678 c0.617,0,1.228-0.267,1.649-0.782l3.583-4.396l-9.697,19.394c-0.026-0.049-0.055-0.097-0.086-0.145l-2.244-3.473l0.905-0.724 c0.44-0.352,0.723-0.864,0.785-1.425c0.063-0.559-0.1-1.122-0.452-1.561l-1.338-1.674l5.006-6.141l0.551,0.448 C239.629,306.523,240.104,306.678,240.576,306.678L240.576,306.678z M294.85,308.671l0.462-0.76 c0.406,0.598,0.836,1.194,1.288,1.788c0.04,0.179,0.082,0.356,0.127,0.534c-0.094-0.116-0.202-0.223-0.323-0.32L294.85,308.671 L294.85,308.671z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.9a7c32604b946a3f85ae4bfc2a5287ef.svg";
export { ForwardRef as ReactComponent };